import React from "react";
import ReactDOM from "react-dom/client";
import {createBrowserRouter, Outlet, RouterProvider} from "react-router-dom";

import ToolTrav22 from "../../tool/trav/22/index.jsx";
import ToolTrav24 from "../../tool/trav/24/index.jsx";
import ToolTrav25 from "../../tool/trav/25/index.jsx";

import PageFrame from "../../react/components/pageFrame";
import * as RouteGroups from '../../react/routes/page/groups';
import * as RouteGroup from '../../react/routes/page/group';
import Api from "../../api/api";
import {UserSettingsProvider} from "../../react/providers/userSettingsProvider";
import TravianServerList from "../../react/components/travian/travianServerList";
import TravianUpdaterInfo from "../../react/components/travian/travianUpdaterInfo";
import {TravianServerProvider} from "../../react/providers/travianServerProvider";
import FacilityRootOverview from "../../FactoryGame/Container/FacilityRootOverview";
import FacilityDetailViewContainer from "../../FactoryGame/Container/FacilityDetailViewContainer";
import BuildingOverviewFrame from "../../travian/Container/BuildingOverviewFrame/BuildingOverviewFrame";
import TribeComparison from "../../travian/Container/TribeComparison/TribeComparison";
import {TranslationProvider} from "../../react/providers/TranslationProvider";
import {TravianConfigProvider} from "../../travian/Providers/TravianConfigProvider";
import TravianMapSql from "../../travian/Container/TravianMapSql/TravianMapSql";
import TravianServerSelector from "../../travian/Container/TravianServerSelector/TravianServerSelector";
import ResourceUpgradeOrder from "../../travian/Container/ResourceUpgradeOrder/ResourceUpgradeOrder";
import ScoutHelper from "../../travian/Container/ScoutHelper/ScoutHelper";

const router = createBrowserRouter([
    {
        path: '',
        element: <Outlet />,
        id: 'root',
        children: [
            { path: 'tool/trav/22', element: <PageFrame pageName='tool/trav/22'><ToolTrav22 /></PageFrame>, loader: async () => await Api.get('userData/travian/incomingAttacks/') },
            { path: 'tool/trav/24', element: <PageFrame pageName='tool/trav/24'><ToolTrav24 /></PageFrame> },
            { path: 'tool/trav/25', element: <PageFrame pageName='tool/trav/25'><ToolTrav25 /></PageFrame> },
            { path: 'tool/trav/buildings', element: <BuildingOverviewFrame /> },
            { path: 'tool/trav/buildings/:gid', element: <BuildingOverviewFrame /> },
            { path: 'tool/trav/tribes', element: <TribeComparison /> },
            { path: 'tool/trav/resourceUpgradeOrder', element: <ResourceUpgradeOrder /> },
            { path: 'tool/trav/scoutHelper', element: <ScoutHelper /> },

            { path: 'tool/satis/1', element: <Outlet />, children: [
                { path: '', element: <FacilityRootOverview /> },
                { path: ':facilityId', element: <FacilityDetailViewContainer /> },
            ] },
            // { path: 'tool/satis/2', element: <RecipeTreeOptimizer /> },

            { path: 'groups', element: <Outlet />, children: RouteGroups.Routes },
            { path: 'group/:groupId', element: <Outlet />, id: 'group', loader: RouteGroup.Loader, children: RouteGroup.Routes },

            { path: 'travian/serverList', element: <PageFrame pageName={'page/travianServerList'}><TravianServerList /></PageFrame> },
            { path: 'travian/serverList/info', element: <PageFrame pageName={'page/travianServerList'}><TravianUpdaterInfo /></PageFrame> },
            { path: 'travian/serverList/select', element: <TravianServerSelector /> },
            { path: 'travian/mapsql', element: <TravianMapSql /> },
        ]
    }
], {
    basename: '/rr'
});

ReactDOM.createRoot(document.getElementById("react-router-root")).render(
    <React.StrictMode>
        <TranslationProvider>
            <UserSettingsProvider>
                <TravianServerProvider>
                    <TravianConfigProvider>
                        <RouterProvider router={router} />
                    </TravianConfigProvider>
                </TravianServerProvider>
            </UserSettingsProvider>
        </TranslationProvider>
    </React.StrictMode>
);
